import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";
import "../../css/Employee.css";

const PurchaseList = () => {
  const [purchaseData, setPurchaseData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showListFilter, setShowListFilter] = useState(false);

  const listFilterRef = useRef(null);

  useEffect(() => {
    api
      .get("/get/purchase/list")
      .then((response) => {
        if (response.data.success) {
          setPurchaseData(response.data.data);
          setFilteredData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching purchase data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const search = searchTerm.toLowerCase();

    if (search.trim() !== "") {
      const filtered = purchaseData.filter((item) => {
        const id = item.purchase_id?.toString().toLowerCase() || "";
        const quantity = item.quantity?.toLowerCase() || "";
        const price = item.price?.toLowerCase() || "";
        const measure = item.measure?.toLowerCase() || "";
        const note = item.note?.toLowerCase() || "";
        const expectedDeliver = item.expected_deliver?.toLowerCase() || "";
        const statut = item.statut?.toLowerCase() || "";
        const provider = item.provider_name?.toLowerCase() || "";
        const material = item.raw_material_name?.toLowerCase() || "";

        return (
          id.includes(search) ||
          quantity.includes(search) ||
          price.includes(search) ||
          measure.includes(search) ||
          note.includes(search) ||
          expectedDeliver.includes(search) ||
          statut.includes(search) ||
          provider.includes(search) ||
          material.includes(search)
        );
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(purchaseData);
    }
    setCurrentPage(1);
  }, [searchTerm, purchaseData]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePerPageChange = (value) => {
    setItemsPerPage(value);
    setShowListFilter(false);
    setCurrentPage(1);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        listFilterRef.current &&
        !listFilterRef.current.contains(event.target)
      ) {
        setShowListFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <section className="employee-section">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Purchase Details</h2>
          <div className="right-filter">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="list-fliter tooltip-wrapper" ref={listFilterRef} data-tooltip="Filter by List">
              <button onClick={() => setShowListFilter(!showListFilter)}>
                <i className="fa-solid fa-filter"></i>
              </button>
              {showListFilter && (
                <div className="filter-data">
                  {[10, 30, 50, 100].map((number) => (
                    <div
                      key={number}
                      className={`filter-option ${
                        itemsPerPage === number ? "selected" : ""
                      }`}
                      onClick={() => handlePerPageChange(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Supplier Name</th>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Unit</th>
                    <th>Message</th>
                    <th>Expected Deliver</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((item, index) => (
                    <tr key={index}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.provider_name || "-"}</td>
                      <td>{item.raw_material_name || "-"}</td>
                      <td className="p-day">{item.quantity || "-"}</td>
                      <td className="check-in">{item.price || "-"}</td>
                      <td>{item.measure || "-"}</td>
                      <td>{item.note || "-"}</td>
                      <td className="check-in">
                        {item.expected_deliver || "-"}
                      </td>
                      <td
                        style={{
                          color:
                            item.statut === "received"
                              ? "#28a745"
                              : item.statut === "ordered"
                              ? "#ff9d17"
                              : undefined,
                          fontWeight: "bold",
                        }}
                      >
                        <span className="status">{item.statut || "-"}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default PurchaseList;
